import { configure, makeUseAxios } from 'axios-hooks';
import axios from 'services/axios';

export default makeUseAxios({ axios: axios });
